import Tag from "./Tag";

const defaultColorMap = {
  critical: "red",
  high: "yellow",
  important: "pink",
  moderate: "blue",
  low: "green",
  unknown: "grey",
};

const TagWrapper = ({ record, colorMap }) => {
  const severity = record?.severity?.toLowerCase() || "";
  return (
    <Tag color={colorMap ? colorMap[severity] : defaultColorMap[severity]} children={severity} />
  );
};

export default TagWrapper;
